import createTypedReducer from "@insite/client-framework/Common/CreateTypedReducer";
import { Draft } from "immer";

interface WaitingType {
    id: string;
    type: number;
    isSaving: boolean;
    total?: number;
}

export interface CustomProductCartStateType {
    waiting: WaitingType[];
    quantity: number;
    currentId?: string | null;
    isSaving: boolean;
}

export type CustomProductCartState = Readonly<CustomProductCartStateType>;

const initialState: CustomProductCartState = {
    waiting: [],
    quantity: 0,
    currentId: null,
    isSaving: false,
};

export const customReducerProductCartReducer = createTypedReducer(initialState, {
    "Custom/ProductCartState/Add": (
        draft: Draft<CustomProductCartState>,
        { id, apiType: type, total, isSaving }: { id: string; apiType: number; total?: number; isSaving?: boolean },
    ) => {
        const newItem = { id, type, total, isSaving: isSaving || false };
        const waiting = [...draft.waiting];
        const found = draft.waiting.find(item => item.id === id && item.type === type);
        if (found == null || waiting.length === 0) {
            waiting.push(newItem);
        }
        const quantity = waiting.length;
        const currentId = waiting[0].id;
        return {
            ...draft,
            waiting,
            quantity,
            currentId,
        };
    },
    "Custom/ProductCartState/MoveQueue": (draft: Draft<CustomProductCartState>) => {
        const waiting: WaitingType[] = [];

        if (draft.waiting.length > 0) {
            waiting.push({
                ...draft.waiting[0],
                isSaving: true,
            });
            for (let i = 1; i < draft.waiting.length; i++) {
                waiting.push(draft.waiting[i]);
            }
        }
        return {
            ...draft,
            waiting,
            isSaving: true,
        };
    },
    "Custom/ProductCartState/Remove": (
        draft: Draft<CustomProductCartState>,
        { id, apiType: type }: { id: string; apiType: number },
    ) => {
        const waiting = draft.waiting.filter(item => item.id !== id);
        const quantity = waiting.length;
        const currentId = waiting.length > 0 ? waiting[0].id : null;

        return {
            ...draft,
            waiting,
            quantity,
            currentId,
            isSaving: false,
        };
    },
});
